import { render, staticRenderFns } from "./PlayPause.vue?vue&type=template&id=1406b9be&scoped=true&"
import script from "./PlayPause.vue?vue&type=script&lang=js&"
export * from "./PlayPause.vue?vue&type=script&lang=js&"
import style0 from "./PlayPause.vue?vue&type=style&index=0&id=1406b9be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1406b9be",
  null
  
)

component.options.__file = "PlayPause.vue"
export default component.exports